/* eslint-disable react/prop-types */
/* eslint-disable import/no-extraneous-dependencies */

import React, { useEffect, useState, useRef } from "react";
import * as echarts from "echarts";
import deepmerge from "deepmerge";

export const AIGraph = ({ spec }) => {
  const containerRef = useRef(null);
  const viewRef = useRef(null);
  const oldSpecJSON = useRef("{}");
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!containerRef.current) {
      return null;
    }

    let runtime;
    try {
      // Initialize chart only once
      runtime = echarts.init(containerRef.current);
      viewRef.current = runtime;

      const handler = () => {
        if (viewRef.current) {
          viewRef.current.resize();
        }
      };

      window.addEventListener("resize", handler);

      // Clean up function
      return () => {
        window.removeEventListener("resize", handler);
        if (viewRef.current) {
          viewRef.current.dispose();
          viewRef.current = null;
        }
      };
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("Error initializing chart:", err);
      setError(`Error initializing chart: ${err.message}`);
    }

    return () => {
      if (runtime) {
        runtime.dispose();
      }
    };
  }, []); // Only run once on mount

  // Update chart data when spec changes
  useEffect(() => {
    if (
      viewRef.current &&
      spec &&
      JSON.stringify(spec) !== oldSpecJSON.current
    ) {
      try {
        viewRef.current.setOption(
          deepmerge.all([
            spec,
            {
              grid: {
                containLabel: true,
                outerBoundsContain: "all",
                outerBoundsMode: "same",
                xAxisName: {
                  show: false,
                },
                yAxisName: {
                  show: false,
                },
              },
              tooltip: {
                confine: true,
              },
              toolbox: {
                show: true,
                feature: {
                  dataZoom: { show: true },
                  saveAsImage: { show: true, name: "chart" },
                },
              },
            },
          ])
        );
        setError(null);
        oldSpecJSON.current = JSON.stringify(spec);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Error updating chart:", err);
        setError(`Error updating chart: ${err.message}`);
      }
    }
  }, [spec]);

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      {error && <div>{error}</div>}
      <div style={{ width: "100%", height: "300px" }} ref={containerRef} />
    </div>
  );
};
